import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DomainPageComponent } from '@technocom/core';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutPageComponent extends DomainPageComponent {
  // empty
}
